import { render, staticRenderFns } from "./DropdownBox.vue?vue&type=template&id=a20bf6de&scoped=true"
import script from "./DropdownBox.vue?vue&type=script&lang=js"
export * from "./DropdownBox.vue?vue&type=script&lang=js"
import style0 from "./DropdownBox.vue?vue&type=style&index=0&id=a20bf6de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a20bf6de",
  null
  
)

export default component.exports